import { IssueStatus, Status } from '@/entities/todo';
import { Status as ChecklistStatus } from '@/entities/checklist/constants';
import {
  checklistStatus as checklistStatusToText,
  issuePriority,
  issueStatusToText,
  issueType,
  todoStatusToText,
} from '@/ui/dictionary';
import { IssuePriority, IssueType } from '@/entities/issue';
import { t } from '@/ui/i18n/i18n';

export const checklistStatusOptions = () => ([
  {
    value: null,
    label: t('form.all-statuses'),
  },
  {
    value: ChecklistStatus.Inactive,
    label: checklistStatusToText(ChecklistStatus.Inactive),
  },
  {
    value: ChecklistStatus.Active,
    label: checklistStatusToText(ChecklistStatus.Active),
  },
]);

export const inspectionStatusOptions = () => ([
  {
    value: Status.Pending,
    label: todoStatusToText(Status.Pending),
  },
  {
    value: Status.Done,
    label: todoStatusToText(Status.Done),
  },
]);

export const issueStatusOptions = () => ([
  {
    value: IssueStatus.Pending,
    label: issueStatusToText(IssueStatus.Pending),
  },
  {
    value: IssueStatus.InProgress,
    label: issueStatusToText(IssueStatus.InProgress),
  },
  {
    value: IssueStatus.Done,
    label: issueStatusToText(IssueStatus.Done),
  },
  {
    value: IssueStatus.CantDo,
    label: issueStatusToText(IssueStatus.CantDo),
  },
]);

export const issueStatusOptionsOverdue = () => ([
  {
    value: IssueStatus.Pending,
    label: issueStatusToText(IssueStatus.Pending),
  },
  {
    value: IssueStatus.InProgress,
    label: issueStatusToText(IssueStatus.InProgress),
  },
]);

export const issuePriorityOptions = () => ([
  {
    value: IssuePriority.Normal,
    label: issuePriority(IssuePriority.Normal),
  },
  {
    value: IssuePriority.High,
    label: issuePriority(IssuePriority.High),
  },
]);

export const issueTypeOptions = () => ([
  {
    value: IssueType.AdHoc,
    label: issueType(IssueType.AdHoc),
  },
  {
    value: IssueType.Automatic,
    label: issueType(IssueType.Automatic),
  },
  {
    value: IssueType.InForm,
    label: issueType(IssueType.InForm),
  },
  {
    value: IssueType.Sensor,
    label: issueType(IssueType.Sensor),
  },
]);

export const todoOverdueOptions = () => ([
  {
    value: null,
    label: t('todo.all-statuses'),
  },
  {
    value: false,
    label: t('todo.due'),
  },
  {
    value: true,
    label: t('todo.overdue'),
  },
]);

export const inspectionOverdueOptions = () => ([
  {
    value: null,
    label: t('inspections.all'),
  },
  {
    value: false,
    label: t('inspections.due'),
  },
  {
    value: true,
    label: t('inspections.overdue'),
  },
]);

export const issueOverdueOptions = () => ([
  {
    value: null,
    label: t('issues.all'),
  },
  {
    value: false,
    label: t('issues.due'),
  },
  {
    value: true,
    label: t('issues.overdue'),
  },
]);
